import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, openContent } from '@nu-art/thunderstorm-frontend/index';
import './Tooltip_Information.scss';
import { generateHex } from '@nu-art/ts-common';
export class Tooltip_Information extends ComponentSync {
    deriveStateFromProps(nextProps) {
    }
    renderContent = () => {
        return _jsxs("div", { className: 'info-tooltip__content', children: [this.props.title && this.renderTitle(this.props.title), this.props.paragraphs && this.props.paragraphs.map(paragraph => {
                    return this.renderParagraph(paragraph);
                })] });
    };
    renderTitle = (title) => {
        return _jsx("span", { className: 'info-tooltip__title', children: title });
    };
    renderParagraph = (paragraph) => {
        return _jsx("p", { className: 'info-tooltip__paragraph', children: paragraph }, generateHex(8));
    };
    render() {
        return _jsx("div", { className: 'info-tooltip', ...openContent.tooltip.left('tooltip-info', this.renderContent), children: "i" });
    }
}
//# sourceMappingURL=Tooltip_Information.js.map